exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3PStCy7pXjaO7IAwTtdTwd .dnn-switch-container {\n  width: 100%;\n}\n._3PStCy7pXjaO7IAwTtdTwd .dnn-switch-container .dnn-switch {\n  float: right;\n}\n", ""]);

// Exports
exports.locals = {
	"editAuthenticationSystem": "_3PStCy7pXjaO7IAwTtdTwd"
};